import { Injectable } from '@angular/core';
import { Capacitor  } from '@capacitor/core';
//import { FirebaseAnalytics } from "@capacitor-community/firebase-analytics";

@Injectable({
  providedIn: 'root',
})
export class DataLayerService {

  constructor(
    ) {}

  public pushEcomEventGTM(nameEvent: string, params: any){
    const config = {
      event: nameEvent,
      ecommerce: params
    };

    if (Capacitor.getPlatform() === 'web') {
      (<any>window).dataLayer = (<any>window).dataLayer || [];
      (<any>window).dataLayer.push(config);
    }
  }

  public pushCustomEventGTM(nameEvent: string){
    if (Capacitor.getPlatform() === 'web') {
      (<any>window).dataLayer = (<any>window).dataLayer || [];
      (<any>window).dataLayer.push({
        event: nameEvent
      });
    }
  }

  public pushPageView(){
    if (Capacitor.getPlatform() === 'web') {
      const pageLocation = window.location.href;
      const pagePath = window.location.pathname;
      const pageTitle = document.title;

      (<any>window).dataLayer = (<any>window).dataLayer || [];
      (<any>window).dataLayer.push({
        event: 'page_view',
        page_location: pageLocation,
        page_path: pagePath,
        page_title: pageTitle
      });
    }
  }

  // Captura el fbclid antes de que el router limpie la URL y lo guarda en la cookie _fbc para GTM
  public captureFbclid(){
    if (Capacitor.getPlatform() === 'web') {
      const fbclid = new URLSearchParams(window.location.search).get('fbclid');
      if (fbclid) {
        const fbc = 'fb.1.' + new Date().getTime() + '.' + fbclid;
        document.cookie = '_fbc=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
        document.cookie = '_fbc=' + fbc + '; path=/; max-age=' + (60 * 60 * 24 * 90) + '; SameSite=Lax';

        (<any>window).dataLayer = (<any>window).dataLayer || [];
        (<any>window).dataLayer.push({ fbclid: fbclid });
      }
    }
  }

}
